import React from "react";
import { Outlet } from "react-router-dom";

const PortalLayout: React.FC = () => {
  return (
    <div className="min-h-screen w-full">
      {/* We removed the "max-w-md", "bg-white", and "shadow" classes.
        Now, the child pages (Plans, Login, Register) have full control 
        over the entire screen.
      */}
      <Outlet />
    </div>
  );
};

export default PortalLayout;
